import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updEventData } from "../../../../../ReduxSlice/Event/eventSlice";
import MainComponentWrapper from "../../../../Common/MainComponentWrapper";
import { EventById, updInstruction } from "../../../../../utils/ApiConstant";
import SettingsTab from "../SettingsTab";
import Input from "../../../../UiElement/FormElement/Input";
import { useEffect } from "react";
import useHttpHook from "../../../../../Hooks/HttpHook";
import { InstructionLanguage } from "../../../../../utils/SettingsLanguages";
import SubmitButtonGroup from "../../../../UiElement/FormElement/SubmitBtnGroup";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../../../utils/notify";

const Instructions = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [loading, sendRequest, error] = useHttpHook();
  const { eventId } = useParams();
  const navigate = useNavigate();
  const { InstructionForm } = InstructionLanguage;
  const instructionsData = useSelector((state) => state.event);
  const dispatch = useDispatch();

  useEffect(() => {
    if (instructionsData.status) {
      showingFormData();
    }
  }, [instructionsData]);

  useEffect(() => {
    if (!instructionsData.status) {
      getEventData();
    }
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const showingFormData = () => {
    reset({
      instruction: instructionsData.data.settings?.instrunction,
    });
  };

  const getEventData = async () => {
    const event = await sendRequest(EventById + eventId);
    dispatch(updEventData(event));
  };

  const onSubmit = async (data) => {
    const updateInstruction = await sendRequest(updInstruction + eventId, {
      method: "post",
      data,
    });
    dispatch(updEventData(updateInstruction));
    navigate(`/myEvents/${eventId}/settings/email-sms`, { replace: true });
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="evntFormUI">
        <form
          className="event-create-form event-settings-form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <SettingsTab Id="instructions" />

          <div className="event-settings-panel">
            <section
              className="event-settings-section"
              aria-labelledby="eventSettingsInstructionsTitle"
            >
              <h2
                className="event-settings-section-title is-accent"
                id="eventSettingsInstructionsTitle"
              >
                {InstructionForm.InstructionsText}
              </h2>
              <p className="event-settings-note">
                Write comma separated instructions
              </p>
              <Input
                element="textarea"
                rows="10"
                placeholder={InstructionForm.FormLabal.DisplayMessage.placeholder}
                Register={register}
                Errors={errors}
                FieldName="instruction"
                Label={InstructionForm.FormLabal.DisplayMessage.label}
                CustomFormGroupCls="event-create-field"
                InputClassName="event-create-textarea event-settings-instructions"
              />
            </section>
          </div>

          <SubmitButtonGroup
            GroupClassName="event-settings-footer"
            HideCancelBtn={true}
            isLoading={loading}
          />
        </form>
      </div>
    </MainComponentWrapper>
  );
};

export default Instructions;
